export class TabRoute {
    name: string;   //Menu Router Name
    menuRoute:any;  //当前菜单路由
    currentRoute: any;  //当前所加载页面的路由。
    history:Array<any> =[]; //历史路由
}